import { getRealmName } from 'src/routes/AuthContext';

/**
 * Returns the Rearchive app base URL for the current realm and environment.
 * Used for the provider sidebar link only: users are taken to the Rearchive
 * default (base) page. Do not append paths or patient deep links here.
 * Example: https://orthocare-rearchive.qa-insights.restoreskills.com
 */
export function getRearchiveUrl(): string {
  const realm = getRealmName();
  if (!realm) {
    return '';
  }
  const hostname = window.location.hostname;
  const environment =
    hostname === 'localhost'
      ? 'qa'
      : hostname.includes('dev')
        ? 'dev'
        : hostname.includes('qa')
          ? 'qa'
          : hostname.includes('stage')
            ? 'stage'
            : hostname.includes('production')
              ? 'production'
              : 'qa';
  return `https://${realm}-rearchive.${environment}-insights.restoreskills.com`;
}

/**
 * Returns the Rearchive patient deep-link URL (SQ-58).
 * Matches rearchive route: /patients/:facilityId/:mrn
 * Example: https://orthocare-rearchive.qa-insights.restoreskills.com/patients/<uuid>/MRN123
 */
export function getRearchivePatientUrl(facilityId: string, mrn: string): string {
  const base = getRearchiveUrl();
  if (!base || !facilityId || !mrn) return '';
  const path = ['patients', encodeURIComponent(facilityId), encodeURIComponent(mrn)].join('/');
  return `${base.replace(/\/$/, '')}/${path}`;
}
